import { Map as ImmutableMap, List as ImmutableList } from 'immutable';
export const aggregateOptionsById = options => {
  return options.reduce((acc, option) => {
    let result = acc.set(option.id, option);
    if (option.options) {
      result = result.merge(aggregateOptionsById(option.options.flat()));
    }
    return result;
  }, ImmutableMap({}));
};
export const flattenOptionsToList = options => {
  return options.reduce((acc, option) => {
    let result = acc.push(option);
    if (option.options) {
      result = result.concat(flattenOptionsToList(option.options.flat()));
    }
    return result;
  }, ImmutableList());
};
export const getAllShortcutOptions = options => options.filter(option => 'shortcut' in option).reduce((acc, option) => {
  return acc.set(option.id, option);
}, ImmutableMap());